module.exports = __webpack_public_path__ + "img/honduras.a751fb5d.svg";